import React, { useEffect, useMemo, useRef, useState } from "react";

// project-imports
import { useCoursesContext } from "../../context/courses_context.js";
import { ADD_COMMENT, ADD_COMMENT_REPLY, COURSE_COMMENTS, UPDATE_COMMENT } from "../../constants/comment.js";
import { useBlogContext } from "../../context/blog_context.js";
import ModalLogin from "../form/ModalLogin.js";
import { useInstructorContext } from "../../context/instructor_context.js";
import { GoogleAnalyticsEnum, triggerFunction } from "../../utils/google-analytics.js";

// third-party
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import ReactQuill from "react-quill-new";
import 'react-quill-new/dist/quill.snow.css';
import "quill-mention/autoregister";
import Quill from "quill";
import { Mention, MentionBlot } from "quill-mention";

Quill.register({
  "blots/mention": MentionBlot,
  "modules/mention": Mention,
});

//added by Longswitch Team end
const SingleCommentQuillMentionForm = ({
  className = "mt-5",
  data = [],
  // comments = [],
  onClickSubmit,
  onClickCancel,
  textareaRef,
  defaultValue = "",
  parent = {},
  commentId = "",
  rows = 1,
  action = "",
}) => {

  // Extracting methods and variables from the context
  const { insertCourseComment, updateCourseComment, isLoading, comments: courseComments } = useCoursesContext();
  const { insertBlogComment, updateBlogComment, comments: blogComments } = useBlogContext();
  const { instructorData } = useInstructorContext();
  const { loginData } = useSelector((item) => item.user);

  // React hook
  let submitButtonRef = useRef(null);
  const quillRef = useRef(null);
  const mentionValuesRef = useRef([]);

  // State variable initialization 
  const [newComment, setNewComment] = useState({
    userId: "",
    userName: "",
    content: defaultValue,
    parentCommentId: action === ADD_COMMENT_REPLY ? commentId : "",
    likes: [],
    lastModifiedDate: "null"
  });
  const [validationError, setValidationError] = useState("");
  const [isLoggedOut, setIsLoggedOut] = useState(false);

  // constant variables
  const comments = parent?.type === COURSE_COMMENTS ? (courseComments ? courseComments : []) : (blogComments
    ? blogComments : []);

  const mentionData = (comments || [])?.map(item => ({
    id: item.userId,
    value: item?.userName
  })).filter((item, index, self) => (index === self.findIndex((t) => (t.id === item.id))))

  const instructor = (instructorData || [])?.filter(
    item => item?.name === (data?.author && data?.author.length && (data?.author?.[0])) || item?.id === data?.instructorId
  );
  const currentInstructor = (instructor || [])?.map(item => ({
    id: item?.id,
    value: item?.name
  })).filter((item, index, self) => (index === self.findIndex((t) => (t.id === item.id))))

  const defaultMentionUser = [
    ...currentInstructor,
    ...mentionData.length ? mentionData : []
  ]

  useEffect(() => {
    mentionValuesRef.current = defaultMentionUser;
  }, [defaultMentionUser]);

  const modules = useMemo(() => ({
    toolbar: [["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],],

    mention: {
      allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
      mentionDenotationChars: ["@"],
      source(searchTerm, renderList) {
        const values = mentionValuesRef.current || [];
        if (!searchTerm.length) return renderList(values);

        const matches = values.filter(u =>
          u.value.toLowerCase().includes(searchTerm.toLowerCase())
        );

        renderList(matches);
      }
    }
  }), []);
  // end Longswitch Team code

  const member = (loginData && loginData.data) || null;
  const currentUserId = member ? member.userRecordId || "" : "";

  const fixListHTML = (html) => {
    try {
      let output = "";
      let currentList = null; // 'ul', 'ol', or null

      const parts = html.split(/(?=<li)/g);

      parts.forEach(part => {
        const isBullet = part.includes('data-list="bullet"');
        const isOrdered = part.includes('data-list="ordered"');

        // Determine which list type this <li> belongs to
        let requiredList = null;
        if (isBullet) requiredList = "ul";
        else if (isOrdered) requiredList = "ol";

        if (requiredList !== currentList) {
          if (currentList) output += `</${currentList}>`;

          if (requiredList) output += `<${requiredList}>`;

          currentList = requiredList;
        }

        part = part
          .replace(/<\/?ol[^>]*>/g, "")
          .replace(/<\/?ul[^>]*>/g, "");

        output += part;
      });

      if (currentList) output += `</${currentList}>`;

      return output;
    } catch (error) {
      console.log("150 : SingleCommentQuillMentionForm : Error in fixListHTML : ", error);
    }
  };

  const handleChange = (content, delta, source, editor) => {
    try {
      if (source !== "user") return;

      const html = editor.getHTML();

      setNewComment(prev => ({
        ...prev,
        content: fixListHTML(html)
      }));

      checkValidation(html);
    } catch (error) {
      console.log("167 : SingleCommentQuillMentionForm : Error in handleChange : ", error);
    }
  };

  const checkValidation = (content) => {
    try {
      if (!content || !content.length) {
        setValidationError("Please enter the message!");
      } else if (content.length > 5000) {
        setValidationError("The Message should contain only 5000 characters!");
      } else {
        setValidationError("");
      }
    } catch (error) {
      console.log("181 : SingleCommentQuillMentionForm : Error while checking comments validation : ", error);
    }

  };

  const handleSubmitComment = async (e) => {
    try {
      // setValue("");
      // setDeltaValue("");
      // newComment.content("");
      // Check validation
      if (validationError || !newComment?.content) {
        setValidationError("Please enter your message");
        return;
      }
      if (!member) {
        return openModalLogin();
      }

      try {
        if (action === ADD_COMMENT) {

          let newCommentPayload = {
            ...newComment,
            userId: currentUserId || "",
            userName: member ? member?.userFullName || "" : "",
          }

          if (parent?.type === COURSE_COMMENTS) {
            triggerFunction(window.location.href + GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_SALESFORCE_COURSE_COMMENT_ADDED);
            newCommentPayload["courseId"] = parent?.id;
            await insertCourseComment(newCommentPayload);
          } else {
            // blog
            triggerFunction(window.location.href + GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_SALESFORCE_BLOG_COMMENT_ADDED);
            newCommentPayload["blogId"] = parent?.id;
            insertBlogComment(newCommentPayload);
          }
          setNewComment((prev) => ({ ...prev, content: "" }))
          // setValue("");

        } else if (action === UPDATE_COMMENT) {
          let newCommentPayload = { content: newComment?.content };

          if (parent?.type === COURSE_COMMENTS) {
            triggerFunction(window.location.href + GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_SALESFORCE_COURSE_COMMENT_UPDATED);
            updateCourseComment(commentId, newCommentPayload, currentUserId);
          } else {
            triggerFunction(window.location.href + GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_SALESFORCE_BLOG_COMMENT_UPDATED);
            updateBlogComment(commentId, newCommentPayload, currentUserId);
          }
          onClickSubmit && onClickSubmit();
        } else if (action === ADD_COMMENT_REPLY) {
          if (!newComment.parentCommentId) {
            console.error("Parent comment ID is missing for a reply.");
            return;
          }
          let newCommentPayload = {
            ...newComment,
            userId: currentUserId || "",
            userName: member?.userFullName || "",
          }
          if (parent?.type === COURSE_COMMENTS) {
            triggerFunction(window.location.href + GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_SALESFORCE_COURSE_COMMENT_REPLY_ADDED);
            newCommentPayload["courseId"] = parent?.id;
            insertCourseComment(newCommentPayload);
          } else {
            // blog
            triggerFunction(window.location.href + GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_SALESFORCE_BLOG_COMMENT_REPLY_ADDED);
            newCommentPayload["blogId"] = parent?.id;
            insertBlogComment(newCommentPayload);
          }
          onClickSubmit();

        }
      } catch (error) {
        console.error("Error submitting comment:", error.message);
      }
    } catch (error) {
      console.log("Error while submitting comment : ", error);
      throw error;
    }

  };

  // cancel button logic 
  const handleCancel = (event) => {
    try {
      if (submitButtonRef.current && !submitButtonRef.current.contains(event.relatedTarget) && newComment.content === "") {
        setValidationError("");
        setNewComment((prev) => ({
          ...prev,
          content: "",
        }));
      }
    } catch (error) {
      console.log("Error while cancelling the comment : ", error);
      throw error;
    }
  }

  const openModalLogin = () => setIsLoggedOut(true);
  const closeModalLogin = () => setIsLoggedOut(false);

  return (

    <>
      <div className="col-lg-12">
        {/* start added by Longswitch Team */}
        <ReactQuill
          ref={quillRef}
          // value={deltaValue}
          onChange={handleChange}
          value={newComment.content}
          theme="snow"
          modules={modules}
          onBlur={handleCancel}
        />
        {/* end */}
        {validationError && (
          <p className="text-danger text-xs mt-1">{validationError}</p>
        )}
      </div>
      <div className="col-lg-12">
        <div className="mt-4 space-x-3">
          <Button
            onClick={handleSubmitComment}
            type="button"
            disabled={isLoading}
            className={"rn-btn comment-btn rounded-pill fs-4 fs-sm-3 text fw-bold"}
            ref={submitButtonRef}
          >

            {isLoading ? (
              <span className="fs-4 fs-sm-3 text fw-bold">
                <span
                  className="spinner-border spinner-border-sm "
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </span>
            ) : (
              <span className="ml--20">
                <span>Submit Now</span>
                <i className="icon-arrow-right-line-right"></i>
              </span>

            )}
          </Button>
          <Button
            type="button"
            pattern="white"
            className={"rn-btn comment-btn cancel-btn ml--15 rounded-pill fs-3 text fw-bold"}
            onClick={() => { onClickCancel && onClickCancel(); setNewComment((prev) => ({ ...prev, content: "" })); setValidationError(""); triggerFunction(window.location.href + GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_SALESFORCE_COMMENT_CANCEL_BUTTON_CLICKED); }}
            disabled={isLoading}
          >
            Cancel
          </Button>
        </div>
      </div>

      {/* Login modal */}
      <ModalLogin show={isLoggedOut} onCloseModalLogin={closeModalLogin} title={'Login to comment'} />
    </>
  );
};

export default SingleCommentQuillMentionForm;
